module.exports = __webpack_public_path__ + "img/2.6528cf95.jpg";